
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/bestil-rejser",
      function () {
        return require("private-next-pages/[region]/[resort]/bestil-rejser.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/bestil-rejser"])
      });
    }
  